<template>
  <Layout v-loading="isLoading">
    <template #top>
      <Head
        :searchConfig="tableData.searchConfig"
        @searchData="searchData"
        @addUser="addUser"
      />
    </template>
    <template>
      <Body
        :headConfig="tableData.headConfig"
        :tableData="data.userList"
        @upgrade="upgrade"
        @updateStatus="updateStatus"
      />
    </template>
    <template #bottom>
      <Foot :total="data.total" @get-data="getPage" />
    </template>

    <template>
      <Register ref="register" @getData="getData" />
    </template>
  </Layout>
</template>

<script>
import getUserPage from "@/api/getUserPage.js";
import updateRoleAdmin from "@/api/updateRoleAdmin.js";
import updateAccountStatus from "@/api/updateAccountStatus.js";
import Layout from "@/components/Layout";
import Head from "@/components/Table/Head";
import Body from "@/components/Table/Body";
import Foot from "@/components/Table/Foot";
import Register from "@/components/Register";
import requstData from "@/mixins/requstData.js";
export default {
  mixins: [requstData({ userList: [], total: 10 })],
  components: {
    Layout,
    Head,
    Body,
    Foot,
    Register,
  },
  data() {
    return {
      tableData: {
        headConfig: {
          select: false,
          key: "id",
          list: [
            { label: "用户id", prop: "userId" },
            { label: "用户账号", prop: "userName" },
            { label: "权限类型", prop: "roleType" },
            { label: "账号状态", prop: "userStatus" },
            { label: "使用者", prop: "operator" },
            { label: "注册日期", prop: "createTime" },
            {
              label: "操作",
              width: "200",
              operation: [
                {
                  type: 1,
                  label: "设为管理员",
                  style: "primary",
                  listeners: "upgrade",
                  show: (data) =>
                    data.roleType === "2" && data.userStatus === "0",
                },
                {
                  type: 2,
                  label: "取消管理员",
                  style: "warning",
                  listeners: "upgrade",
                  confirm: "确定取消？",
                  show: (data) =>
                    data.roleType === "1" && data.userStatus === "0",
                },
                {
                  type: 3,
                  label: "启用",
                  style: "success",
                  listeners: "updateStatus",
                  show: (data) => data.userStatus === "1",
                },
                {
                  type: 4,
                  label: "停用",
                  style: "danger",
                  confirm: "确定停用？",
                  listeners: "updateStatus",
                  show: (data) => data.userStatus === "0",
                },
              ],
            },
          ],
        },
        searchConfig: {
          list: [
            {
              type: "input",
              model: "userId",
              span: 4,
              placeholder: "请输入用户id",
            },
            {
              type: "input",
              model: "userName",
              span: 4,
              placeholder: "请输入用户账号",
            },
            {
              type: "select",
              model: "roleType",
              span: 3,
              placeholder: "权限类型",
              options: [
                { label: "管理员", value: 1 },
                { label: "普通用户", value: 2 },
              ],
            },
            {
              type: "button",
              span: 5,
              operation: [
                {
                  type: 1,
                  label: "查询",
                  style: "primary",
                  listeners: "searchData",
                },
                {
                  type: 2,
                  label: "+新增用户",
                  style: "success",
                  listeners: "addUser",
                },
              ],
            },
          ],
        },
      },
    };
  },
  methods: {
    async requst(params) {
      return await getUserPage(params);
    },
    async upgrade(data) {
      this.isLoading = true;
      let res = await updateRoleAdmin({
        otherId: data.userId,
        userType: data.roleType === "1" ? 2 : 1,
      });
      this.isLoading = false;
      if (res === "ok") {
        this.$message({
          showClose: true,
          type: "success",
          message: `账户${data.userName}已${
            data.roleType === "1" ? "取消" : "设为"
          }管理员`,
        });
        this.getData();
      }
    },
    addUser() {
      this.$refs.register.show();
    },
    async updateStatus(data) {
      this.isLoading = true;
      let res = await updateAccountStatus({
        id: data.userId,
        status: 1 - JSON.parse(data.userStatus),
      });
      this.isLoading = false;
      if (res === "ok") {
        this.$message({
          showClose: true,
          type: "success",
          message: `账户${data.userName}已${
            data.userStatus === "1" ? "启用" : "停用"
          }`,
        });
        this.getData();
      }
    },
  },
};
</script>

<style lang="less">
.messageCancel {
  color: #fff;
  background-color: #f56c6c;
  border-color: #f56c6c;

  &:hover {
    background: #f78989;
    border-color: #f78989;
    color: #fff;
  }
}
</style>
